import GraphQL from '@app/model/_common/service/GraphQL';
import { gql } from 'graphql-request';
import { PRINCIPAL_FRAGMENT } from '@app/model/authentication/service/AuthorizationGraphQlFragments';


export const PARSER_WEB_HOTELIER_TOKEN_MUTATION: GraphQL = {
	name: "parseToken",
	gql: gql`
			${PRINCIPAL_FRAGMENT}
      query parseToken($token: String!, $htlCode: String!) {
          parseToken(token: $token, htlCode: $htlCode) {
							principalWithToken {
                  principal {
                      ...PrincipalFields
                  }
                  token
              }
							webhotelierId
							isNew
					}
      }
	`
}